/**
 * @module: 我的投递store
 * @author: Teacher Tang
 * @date: 2019-09-29 14:00:00
 */

import { observable, action } from 'mobx';
import { ajax } from '@clouderwork/ywk';
import { withRole } from '@src/utils/residentNew';

interface MyDeliveryParams {
  // 状态
  status: number,
  // 每页请求条数
  pagesize: number,
  // 第几页
  pagenum: number,
  // 是否是下拉刷新
  pull?: boolean
}


class Delivery {
  // 是否加载中
  @observable loading: boolean = true;
  // 当前显示tab
  @observable curTab: number = 1;
  // 距离顶部的滚动高度
  @observable scrollTop: number = 0;
  // 当前投递
  @observable offers: any = { 1: [], 2: [], 3: [], 4: [], 5: [] };
  // 当前投递
  @observable offerTotals: any = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
  // 包含的id
  @observable offerIds: any = { 1: {}, 2: {}, 3: {}, 4: {}, 5: {} };

  /** 获取投递数据 */
  @action.bound
  async getDeliveryOffers(query: MyDeliveryParams, cbFn?: Function) {
    const res = await ajax.getJson('/resident/api/user/delivery-offers', withRole(query, 2))
    if (res.error_code === 0) {
      // this.offers[query.status] = [...this.offers[query.status], ...res.offers]
      this.offerTotals[query.status] = res.total;
      // 过滤重复的情况
      res.offers.forEach(item => {
        if (!this.offerIds[query.status][item.delivery_id]) {
          if (query.pull) {
            this.offers[query.status].unshift(item)
          } else {
            this.offers[query.status].push(item)
          }
        }
        this.offerIds[query.status][item.delivery_id] = 1
      });
      if (cbFn) cbFn();
    } else {
      this.offerTotals[query.status] = 0;
      this.offers[query.status] = []
    }
    this.loading = false
  }

  /** 清空当前状态数据 */
  @action.bound
  clearData(status: number) {
    this.loading = true;
    this.curTab = status;
    this.offers[status] = [];
    this.offerIds[status] = {};
  }

  /** 设置滚动高度 */
  @action.bound
  setScrollTop(top: number) {
    this.scrollTop = top
  }
}

export default Delivery;
